export default {"src":"/_next/static/media/tanTheta.0e489fb5.svg","height":65,"width":536,"blurWidth":0,"blurHeight":0};